/* global APP_BUILD */

export default function () {
  return APP_BUILD === 'self-service';
}
